/**
 * VIP join flow — always uses window.startEnrollment (polyfilled in theme.liquid).
 */
function triggerRewardsJoin() {
  window.startEnrollment("shapesetter.measureandmade.com", "CUSTOMER");
}

function triggerDealerJoin() {
  window.startEnrollment("shapesetter.measureandmade.com", "DEALER");
}

// app rendered code
if (window.location.pathname === "/pages/vip-insider") {
  setTimeout(function () {
    fetch(
      "https://www.measureandmade.com/_get_template?page=template-vip-insider"
    )
      .then((response) => response.text())
      .then((data) => {
        const mainContent = document.querySelector("#main-content");
        if (mainContent) {
          mainContent.insertAdjacentHTML("afterend", data);
        }

        const joinCustomerLinks = document.querySelectorAll(
          'a[href="#join-customer"]'
        );
        if (joinCustomerLinks) {
          joinCustomerLinks.forEach((link) => {
            link.addEventListener("click", function (event) {
              event.preventDefault();
              window.location.hash = "";
              setTimeout(function () {
                window.location.hash = "#join-customer";
              }, 1000);
            });
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching VIP Insider template:", error);
      });
  }, 1000);
} else if (window.location.search === "?newbanner=1") {
  const matches = window.location.pathname.match(/^\/collections\/(\w+)/);
  if (matches) {
    setTimeout(function () {
      fetch(
        "https://www.measureandmade.com/_get_template?page=template-" +
          matches[1]
      )
        .then((response) => response.text())
        .then((data) => {
          const bannerSection = document.querySelector(
            "#shopify-section-collection_banners"
          );
          if (bannerSection) {
            bannerSection.remove();
          }

          const contentWrapper = document.querySelector(".content-wrapper");
          if (contentWrapper) {
            contentWrapper.insertAdjacentHTML("afterbegin", data);
          }
        })
        .catch((error) => {
          console.error("Error fetching collection template:", error);
        });
    }, 10);
  }
}

if (
  window.location.pathname === "/pages/vip-insider" ||
  document.querySelector(".hide-when-logged-in")
) {
  setTimeout(function () {
    fetch("https://shop.measureandmade.com/apps/loggedincustomer")
      .then((response) => response.json())
      .then((userData) => {
        if (userData.email) {
          document.querySelectorAll(".hide-when-logged-in").forEach((element) => {
            element.classList.add("hidden");
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, 1500);
}

window.addEventListener("hashchange", function (e) {
  const currentHash = window.location.hash;

  if (currentHash === "#join-dealer") {
    e.preventDefault();
    window.location.hash = "";
    triggerDealerJoin();
    return;
  }

  if (currentHash === "#join-customer") {
    e.preventDefault();
    window.location.hash = "";
    triggerRewardsJoin();
  }
});

/**
 * /pages/rewards — Yotpo injects the hero via JS (instance 99264).
 * Use document-level delegation so clicks work even after Yotpo re-renders the button.
 */
function initRewardsPageYotpo() {
  if (window.location.pathname !== "/pages/rewards") return;
  if (document.documentElement.dataset.mmRewardsJoinDelegated === "true") return;
  document.documentElement.dataset.mmRewardsJoinDelegated = "true";

  document.addEventListener(
    "click",
    function (event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const joinButton = target.closest(
        ".yotpo-register-link .yotpo-action-button-widget button, .yotpo-register-link button"
      );
      if (!joinButton) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      triggerRewardsJoin();
    },
    true
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initRewardsPageYotpo);
} else {
  initRewardsPageYotpo();
}
